import { render, staticRenderFns } from "./SpecificationModal.vue?vue&type=template&id=0890d37b&scoped=true"
import script from "./SpecificationModal.vue?vue&type=script&lang=js"
export * from "./SpecificationModal.vue?vue&type=script&lang=js"
import style0 from "./SpecificationModal.vue?vue&type=style&index=0&id=0890d37b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890d37b",
  null
  
)

export default component.exports